import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'SOLID CLASSES - Quality Education in Jodhpur',
  description = 'SOLID CLASSES offers comprehensive education for 6th to 12th standard students, including NEET-JEE preparation. Expert faculty, personalized attention, and proven track record.',
  keywords = 'SOLID CLASSES, education, Jodhpur, NEET, JEE, coaching, physics, chemistry, mathematics, biology',
  image = '/logo.png',
  url = 'https://solid-classes.vercel.app/',
  type = 'website'
}) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "EducationalOrganization",
    "name": "SOLID CLASSES",
    "description": description,
    "url": url,
    "logo": `${url}${image}`,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "1st Floor, Bhati Cement, Pratap Nagar",
      "addressLocality": "Jodhpur",
      "addressRegion": "Rajasthan",
      "postalCode": "342001",
      "addressCountry": "IN"
    },
    "telephone": "+91 90790-35708",
    "email": "solidclassesjodhpur@gmail.com",
    "openingHours": "Mo-Sa 09:00-19:00",
    "sameAs": [
      "https://www.facebook.com/solidclasses",
      "https://www.instagram.com/solidclasses"
    ]
  };

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={`${url}${image}`} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${url}${image}`} />
      
      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content="SOLID CLASSES" />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default SEO; 
